module.exports = __webpack_public_path__ + "img/profile-tile-02.08acfb6c.jpg";